
import React from "react";


import "react-accessible-accordion/dist/fancy-example.css";

const AccordianFaq = ({ eventData }) => {


  // Initializing state to store event data
  if (!eventData || !eventData.FAQ || eventData.length === 0) {
    return;
  }

  return (

    <>
      {eventData.FAQ.map((faq) => (
        <div key={faq.FAQID} className="collapse collapse-arrow font-manrope font-semibold w-full md:w-[90%] bg-white rounded-2xl mb-2">
          {faq.question.length>0 && faq.answer.length>0? (<>
          <input type="checkbox" name="my-accordion-2" />
          <div className="collapse-title text-xl ">{faq.question}</div>
          <div className="collapse-content">
            <p className="text-base ">{faq.answer}</p>
          </div>
          </>): ('')}
          
        </div>
      ))}





{/*       
      <div className="collapse collapse-arrow font-manrope font-semibold w-full md:w-[90%] bg-white rounded-2xl mb-2">
        <input type="checkbox" name="my-accordion-2"/>
        <div className="collapse-title text-xl ">This is just for testing</div>
        <div className="collapse-content">
          <p className="text-base ">Need to remove this one</p>
        </div>
      </div>
      <div className="collapse collapse-arrow font-manrope font-semibold w-full md:w-[90%] bg-white rounded-2xl mb-2">
        <input type="checkbox" name="my-accordion-2" />
        <div className="collapse-title text-xl ">This is just for testing</div>
        <div className="collapse-content">
          <p className="text-base ">Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium nihil saepe amet delectus voluptatibus velit perferendis asperiores, quas culpa beatae libero enim sed at corporis!</p>
        </div>
      </div>
      <div className="collapse collapse-arrow font-manrope font-semibold w-full md:w-[90%] bg-white rounded-2xl mb-2">
        <input type="checkbox" name="my-accordion-2" />
        <div className="collapse-title text-xl ">This is just for testing</div>
        <div className="collapse-content">
          <p className="text-base ">Need to remove this one</p>
        </div>
      </div>
      <div className="collapse collapse-arrow font-manrope font-semibold w-full md:w-[90%] bg-white rounded-2xl mb-2">
        <input type="checkbox" name="my-accordion-2" />
        <div className="collapse-title text-xl ">This is just for testing</div>
        <div className="collapse-content">
          <p className="text-base ">Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea sunt beatae voluptates perspiciatis enim minima molestias libero recusandae voluptatem. Dolore totam accusantium optio ut. Labore voluptatem eaque enim minima natus numquam? Quo.</p>
        </div>
      </div> */}


    </>
  );
};

export default AccordianFaq;
